export default function NotFound() {
    return (
      <div className="not-found">
        <h1>404 - Página Não Encontrada</h1>
      </div>
    );
  }